module.exports = __webpack_public_path__ + "static/media/self-employee.e567e6f7.png";